import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import SpaceParticles from "../../components/Particles/SpaceParticles";
import { getBlogPosts } from "../../firebase/blogServices";
import { FaArrowLeft, FaCalendarAlt, FaUser, FaTag } from "react-icons/fa";
import "./BlogPost.css";
import ReactGA from "react-ga4";
import { slugify } from "../../utils/slugify";

const BlogPost = () => {
  const { postSlug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        // Get all posts and find the one with a matching slug
        const allPosts = await getBlogPosts();
        const blogPost = allPosts.find(
          (post) => slugify(post.title) === postSlug
        );

        if (blogPost) {
          setPost(blogPost);
          // Track post view
          ReactGA.event({
            category: "User",
            action: "Read Blog Post",
            label: blogPost.title,
          });
        } else {
          setError("Post não encontrado.");
          navigate("/blog", { replace: true });
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blog post:", err);
        setError(
          "Falha ao carregar o artigo. Por favor, tente novamente mais tarde."
        );
        setLoading(false);
      }
    };

    fetchPost();
  }, [postSlug, navigate]);

  // Format date to Brazilian format
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Handler for tag clicks
  const handleTagClick = (tag) => {
    // Track tag click
    ReactGA.event({
      category: "User",
      action: "Clicked Blog Tag",
      label: tag,
    });

    // Navigate to blog page with tag filter
    navigate(`/blog?tag=${encodeURIComponent(tag)}`);
  };

  return (
    <div className="blog-post-page">
      <Navbar />
      <main className="blog-post-main">
        {loading ? (
          <div className="blog-post-loading">
            <div className="loading-spinner"></div>
            <p>Carregando artigo...</p>
          </div>
        ) : error ? (
          <div className="blog-post-error">
            <p>{error}</p>
          </div>
        ) : (
          <>
            <div className="blog-post-back-link">
              <Link to="/blog">
                <FaArrowLeft /> Voltar para o Blog
              </Link>
            </div>

            <article className="blog-post-article">
              {post.imageUrl && (
                <div className="blog-post-hero-image">
                  <img src={post.imageUrl} alt={post.title} />
                </div>
              )}

              <div className="blog-post-header">
                <h1 className="blog-post-title">{post.title}</h1>
                <div className="blog-post-meta">
                  {post.author && (
                    <span className="blog-post-author">
                      <FaUser /> {post.author}
                    </span>
                  )}
                  <span className="blog-post-date">
                    <FaCalendarAlt /> {formatDate(post.createdAt)}
                  </span>
                </div>
              </div>

              <div
                className="blog-post-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />

              {post.tags && post.tags.length > 0 && (
                <div className="blog-post-tags">
                  <span className="tags-label">
                    <FaTag /> Tags:
                  </span>
                  {post.tags.map((tag, index) => (
                    <button
                      key={index}
                      className="blog-post-tag"
                      onClick={() => handleTagClick(tag)}
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              )}
            </article>
          </>
        )}
      </main>
      <Footer />
      <SpaceParticles />
    </div>
  );
};

export default BlogPost;
